import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './mentorForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './mentorActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import { getLista as getListaTexto } from '../texto/textoActions';
import TextoInput from '../texto/textoInput';

class Mentor extends Component {

	state = {
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaTexto();
    }

    render() {

        return (
			<>
				<div 
					style={{
						display: 'flex',
						flexDirection: 'row',
						justifyContent: 'center',
						flexWrap: 'wrap',
						backgroundColor: '#0F2748',
						width: '100%',
						padding: 16,
						color: '#ffffff'
					}}>
					<p style={{ margin: 0, padding: 0 }}>{this.props.mentorTitulo}</p>

					<TextoInput chave='mentorTitulo' />
				</div>

				<Background
					backgroundPosition={'center'}
					gradientStart='#0F2748'
					gradientEnd='#19CCCC'>
					<Content>
						<Aguardando aguardando={this.props.aguardando} />

						{this.props.modoTela == 'cadastro' ? (
							<Form onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'visualizacao' ? (
							<Form visualizacao onSubmit={this.props.salvar} />
						) : null}
						{this.props.modoTela == 'exclusao' ? (
							<Form excluir onSubmit={this.props.excluir} />
						) : null}
						{this.props.modoTela == 'lista' ? this.lista() : null}
					</Content>
				</Background>
			</>
        )
    }

	lista() {

		let lista = this.props.lista;

		return (
			<Row alignCenter>
				{this.props.sessao.administrador &&
				<Grid cols='12 6 4 3'>
					<Button
						text='Adicionar'
						type={'primary'}
						icon={'fa fa-plus'}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm({});
						}} />
				</Grid>}

				<Grid cols='12 12 12 10'>
					<div
						style={{
							display: 'flex',
							flexDirection: 'row',
							flexWrap: 'wrap',
							justifyContent: 'center'
						}}>
						{lista.map(item => (
							<div
								style={{ 
									backgroundColor: '#ffffff',
									display: 'flex',
									flexDirection: 'column',
									margin: 8,
									borderRadius: '5%',
									padding: 16,
									width: 330,
									alignItems: 'center'
								}}>
								<a href={item.link} target='_blank'>
									<img 
										style={{
											width: 200,
											height: 200,
											marginLeft: 50,
											marginRight: 50,
											backgroundColor: '#0F2748',
											padding: 2,
											borderRadius: '50%'
										}}
										src={item.imagem}
										title={item.nome}>
									</img>
								</a>
								<label style={{ padding: 16, margin: 0, fontSize: 22, textAlign: 'center', color: '#0F2748' }}>{item.nome}</label>
								<label style={{ padding: 0, margin: 0, textAlign: 'center', color: '#0F2748' }}>Formação</label>
								<p style={{ padding: 0, margin: 0, textAlign: 'center', color: '#0F2748' }}>{item.formacao}</p>
								<label style={{ padding: 0, margin: 0, textAlign: 'center', color: '#0F2748' }}>Área de Atuação</label>
								<p style={{ padding: 0, margin: 0, textAlign: 'center', color: '#0F2748' }}>{item.area}</p>
								
								{this.props.sessao.administrador &&
								<div style={{ margin: 4, width: '100%', textAlign: 'center'}}>
									<ButtonTable
										type={'primary'}
										icon={'fas fa-pencil-alt'}
										visible={true}
										event={() => {
											this.props.setModoTela('cadastro', {
												...item
											});
											this.props.initForm({
												...item
											});
										}} />

									<ButtonTable
										type={'danger'}
										icon={'fas fa-trash'}
										visible={true}
										event={() => {
											this.props.setModoTela('exclusao', {
												...item
											});
											this.props.initForm({
												...item
											});
										}} />
								</div>}
							</div>
						))}
					</div>
				</Grid>
			</Row>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.mentor.modoTela,
	aguardando: state.mentor.aguardando,
	lista: state.mentor.lista,
	mentorTitulo: state.texto.lista.filter(item => item.chave == 'mentorTitulo').map(item => item.valor)[0]
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista,
	getListaTexto
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Mentor);
